export const wind = () => {
  const triggerWord = "windywellington"
  let sequence = ""

  const capture = event => {
    sequence += event.key
    if (sequence.includes(triggerWord)) {
      const logo = document.querySelector(".header__logo")
      const logoFooter = document.querySelector(".footer__brand")
      const spinner = document.createElement("div")
      const spinnerFooter = document.createElement("div")
      spinner.className = "gwrc-egg"
      spinnerFooter.className = "gwrc-egg gwrc-egg--footer"
      logo.appendChild(spinner)
      logoFooter.appendChild(spinnerFooter)

      setTimeout(() => {
        document.querySelector(".content-container").classList.add("gwrc-egg-body")
      }, 1000)

      document.removeEventListener("keydown", capture)
    }
    sequence = sequence.slice(-triggerWord.length)
  }

  document.addEventListener("keydown", capture)
}

export const isPrintableCharacter = str => {
  return str.length === 1 && str.match(/\S/)
}

export const setSubmenuFocusToLastMenuItem = submenu => {
  const menuItems = submenu.querySelectorAll("a[role='menuitem']")
  const lastElement = menuItems[menuItems.length - 1]

  if (lastElement) {
    lastElement.focus()
  }
}

export const setSubmenuFocusToFirstMenuItem = submenu => {
  const menuItems = submenu.querySelectorAll("a[role='menuitem']")
  const firstElement = menuItems[0]

  if (firstElement) {
    firstElement.focus()
  }
}

export const setSubmenuFocusToNextMenuItem = submenu => {
  const current = document.activeElement
  const links = [...submenu.querySelectorAll("a")]

  if (current === links[links.length - 1]) {
    links[0].focus()
  } else {
    const index = links.findIndex(l => l === current)
    links[index + 1].focus()
  }
}

export const setSubmenuFocusToPreviousMenuItem = submenu => {
  const current = document.activeElement
  const links = [...submenu.querySelectorAll("a")]

  if (current === links[0]) {
    links[links.length - 1].focus()
  } else {
    const index = links.findIndex(l => l === current)
    links[index - 1].focus()
  }
}

export const setSubmenuFocusByMenuItemFirstCharacter = (submenu, char) => {
  const links = [...submenu.querySelectorAll("a")]
  const index = links.find(l => {
    return (
      l.textContent
        .trim()
        .toLowerCase()
        .substring(0, 1) === char.toLowerCase()
    )
  })

  if (index) {
    index.focus()
  }
}

export const isMobileQuery = window.matchMedia("(max-width: 576px)")

export const openAccordionItem = item => {
  const button = item.querySelector("button")
  const itemLoc = item.getBoundingClientRect()
  const elegantSpacing = window.innerHeight * 0.1
  window.scrollTo({
    top: itemLoc.top + window.scrollY - elegantSpacing,
    behavior: "smooth",
  })

  if (button) {
    const content = document.getElementById(button.getAttribute("aria-controls"))
    if (content.getAttribute("aria-hidden") === "true") {
      content.setAttribute("aria-hidden", "false")
      button.setAttribute("aria-expanded", "true")
      button.classList.toggle("close")
    }
  }
}
